const doc = [({"da":({"models":({"proposal_vote_result":({"no":"Nej", "yes":"Ja"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;